<template>
	<v-container fill-height fluid class="pa-0">
		<Perfil :mostrar="editarPerfil" :perfil="perfil" :acessos="acessosPerfil" @fechar="fechar()"/>
		<Excluir :mostrar="excluirPerfil" :perfil="perfil" @fechar="fechar()" @atualizaPerfis="atualizaPerfis($event)"/>
		<Novo :mostrar="abrirNovo" @fechar="fechar()"/> 
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoPerfil()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170" 
						locale="pt-BR" dense fixed-header class="table-item" :items="perfis" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, 
	showError, 
	//showSuccess 
	} from "@/config/global"
	import axios from 'axios'
	import Perfil from '@/components/cadastros/perfisAcessos/Perfil'
	import Excluir from '@/components/cadastros/perfisAcessos/Excluir'
	import Novo from '@/components/cadastros/perfisAcessos/Novo'
	import metodos from '@/mixins/metodos.js'
	import TIPOACESSOS from '@/Enums/TipoAcessos'
	//import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
        components:{Perfil, Novo, Excluir},
		data(){
			return {
				tipoAcessos: TIPOACESSOS,
                loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 15,
                perfis: [],
                perfil: {},
                acessosPerfil: [],
                editarPerfil: false,
                abrirNovo: false,
                excluirPerfil: false,
				fields: [
					{value: 'id_perfil', text: 'Código', align: 'center'},
					{value: 'nome', text: 'Nome', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaPerfis(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/perfis/read.php`

				axios.get(url)
						.then(res => {
                            
							if(res.data.codigo == "01"){
								this.perfis = res.data.dados
							}
							this.totalPaginas = Math.ceil(this.perfis.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			editar(perfil){
                this.perfil = perfil
                this.buscaAcessosPerfil(perfil.id_perfil)
				this.editarPerfil = true
            },
            
            buscaAcessosPerfil(id){
                const url = `${baseApiUrl}/Cadastros/perfis/readAcessos.php?id=${id}`

				axios.get(url)
                    .then(res => {
						if(res.data.codigo == "01"){
                            this.acessosPerfil = res.data.dados.map(p => {
                                return{
                                    ativo: p.ativo == "1" ? true : false,
                                    id_item: p.id_item,
									nome_item: p.nome_item,
									tipo_acesso: p.tipo_acesso,
                                }
							})
							
							this.acessosPerfil.forEach(v=>{
								
								for(let t in this.tipoAcessos){
									if(this.tipoAcessos[t] == v.tipo_acesso){
										v.tipo_acesso = t.toLowerCase()
									}
								}
								
							})
                        }
                    })
                    .catch({showError})
            },

			criarNovoPerfil(){
				this.abrirNovo = true
			},

			excluir(perfil){
                this.perfil = perfil
                this.excluirPerfil = true
            },
            
            fechar(){
                this.perfil = {}
                this.acessosPerfil = []
                this.editarPerfil = false
                this.abrirNovo = false
                this.excluirPerfil = false
            },

            atualizaPerfis(event){
                let idx = this.perfis.findIndex(v => {
                    return v.id_perfil == event
                })

                this.perfis.splice(idx,1)
            }

		},

		created(){
			this.buscaPerfis()
		}
	}
</script>

<style scoped>

</style>